import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { CancellationPolicy } from './types';

type Variables = { startTime: Date };
type Response = {
  insuranceOptions: [
    {
      name: string;
      id: number;
      percentage: number;
      fixedAmount: number | null;
      meta: any;
    }
  ];
  cancellationOptions: CancellationPolicy[];
};

export const useAddOns = createQuery<Response, Variables, AxiosError>({
  queryKey: ['add-ons', 'startTime'],
  fetcher: ({ startTime }) => {
    const startTimeParam = encodeURIComponent(startTime.toISOString());

    return client
      .get(`v2/reservations/add-ons?start_time=${startTimeParam}`)
      .then((response) => {
        return response.data.data;
      });
  },
});
